import React from 'react';
import styles from './PageStub.module.css';

export default function ProjectPhotos() {
  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <div className={styles.icon}><PhotosIcon /></div>
        <h2 className={styles.title}>Photos</h2>
        <p className={styles.sub}>Site photography and progress documentation coming soon.</p>
      </div>
    </div>
  );
}

const PhotosIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <rect x="4" y="10" width="32" height="24" rx="3" stroke="currentColor" strokeWidth="1.8"/>
    <circle cx="20" cy="22" r="6" stroke="currentColor" strokeWidth="1.6"/>
    <path d="M14 10l2-4h8l2 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="31" cy="16" r="1.5" fill="currentColor"/>
  </svg>
);
